module.exports = __webpack_public_path__ + "static/media/game_icon_archero2.55dc85c3.png";